import { Banner } from '@servicetitan/design-system';

export const OutboundCallsAllowedBanner = () => {
  return (
    <Banner title={''} status='warning' icon={true}>
      Click to call is unavailable. Please complete the following steps to
      enable outbound calls:
      <ul>
        <li>A basic or advanced user seat</li>
        <li>Assigned to a phone number</li>
        <li>E911 address configured</li>
      </ul>
    </Banner>
  );
};
